'use client';
import { isString, objectKeys } from '@s7/utils';
import { rem } from '../../../modules/sizes/impl/units/units.js';

/**
 * Генерирует определения CSS переменных или получает значения CSS переменных с необязательными значениями по умолчанию.
 *
 * @template T - Тип входных данных, который может быть строкой, представляющей имя переменной,
 * или объектом, сопоставляющим имена переменных с их значениями.
 *
 * @param {T} vars - Если передана строка, она будет отформатирована как CSS-переменная. Если передан объект,
 * он сопоставит каждый ключ как CSS-переменную с соответствующим значением.
 *
 * @param {string | number} [defaultValue] - Необязательное значение по умолчанию, которое будет использовано, если CSS-переменная не определена.
 * Это применяется только тогда, когда `vars` является строкой.
 *
 * @returns {T} Для строкового входа возвращает строку, представляющую CSS-переменную с необязательным значением по умолчанию.
 * Для входа в виде объекта возвращает объект, сопоставляющий имена CSS-переменных с их соответствующими значениями.
 */ const cssVars = (vars, defaultValue)=>{
    if (isString(vars)) {
        return defaultValue ? `var(--ds-${vars},${rem(defaultValue)})` : `var(--ds-${vars})`;
    }
    return objectKeys(vars).reduce((result, current)=>{
        result[`--ds-${current}`] = vars[current];
        return result;
    }, {});
};

export { cssVars };
//# sourceMappingURL=cssVars.js.map
